// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'styles/colors'
import { mediaMax } from 'styles/media'
import { spacing, zIndexes } from 'frontend_core/dist/styles/variables'
import Button from 'components/atoms/Button'

const sidebarInboxWidth = 370
const containerHeight = 74
const containerHeightSp = 65
const sidebarWidth = 250
const spacingToSidebar = sidebarWidth + spacing.huge * 2
// SidebarInboxのwidthが広くデザインが崩れるためspacing.huge*2にはしない
const spacingToSidebarInbox = sidebarInboxWidth + spacing.huge

const Base = styled.div`
  height: ${containerHeight}px;
  ${mediaMax.phone`
    height: ${containerHeightSp}px;
  `};
`

const Container = styled.div`
  ${'' /* position: fixed;
  bottom: 0; */}
  height: ${containerHeight}px;
  background-color: ${Colors.mono.white};
  z-index: ${zIndexes.baloon};
  ${({ isWithoutSidebar }) => {
    if (isWithoutSidebar) {
      return css`
        width: 100%;
        max-width: 810px;
      `
    } else {
      return css`
        width: calc(100% - ${spacingToSidebar}px);
        max-width: 600px;
      `
    }
  }}
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `}
  ${mediaMax.phone`
    left: 0;
    width: 100%;
    max-width: none;
    height: ${containerHeightSp}px;
    ${({ textAlignSp }) =>
      textAlignSp &&
      css`
        text-align: ${textAlignSp};
      `}
  `}
`

const Content = styled.div`
  padding: ${spacing.medium}px 0;
  ${mediaMax.phone`
    padding: ${spacing.small_3}px;
  `};
`

const Line = styled.div`
  border-top: 1px solid ${Colors.mono.gray30};
  ${mediaMax.phone`
    margin: 0 ${spacing.small_3}px;
  `};
`

const ButtonContainer = styled.div`
  display: inline-block;
  width: 50%;
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `};
`

export default props => (
  <div>
    <Container textAlign="left" textAlignSp="center" isWithoutSidebar={true}>
      <Line />
      <Content>
        <ButtonContainer textAlign="left">
          <Button
            onClick={props.onClickBack}
            type="anchor"
            colorType="gray"
            buttonType="medium"
            fontWeight
            disabled={props.isBackButtonDisabled}
          >
            {i18n.t('戻る')}
          </Button>
        </ButtonContainer>
        <ButtonContainer textAlign="right">
          <Button
            onClick={props.onSubmit}
            type="anchor"
            colorType="blue"
            buttonType="medium"
            buttonMargin="0 0 0 12px"
            fontWeight
            disabled={props.isSubmitButtonDisabled}
          >
            {i18n.t('保存する')}
          </Button>
        </ButtonContainer>
      </Content>
    </Container>
    <Base />
  </div>
)
